export const currency = {
  IDR: 'Rp',
}
